import styled from 'styled-components'

export const Button = styled.button`
    background-color: white;
    border: solid 1px #16bfe6;
    border-radius: 8px;
    color: #18182d;
    padding: 0.8rem 1rem;
    cursor: pointer;
    width: 13rem;
    font-weight: 800;
    font-size: 0.9rem;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;

    &:hover {
        color: #18182d;
        background-color: #16bfe6;
        transition-duration: 0.1s;

        a {
            color: #18182d;
        }
    }
    
    &:focus {
        outline: none;
    }

    a {
        color: #429bd5;
    }
`